import axiosInstance from '../../../config/axiosInstance';
const SupplierPartService = {
    async GetAllSupplierParts(redirectCallback, PartID) {
        try {
            const response = await axiosInstance.get(`/Part/GetAllSupplierParts?PartID=${PartID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async GetAvaliableSupplier(redirectCallback, PartID) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Part/GetAvailableSupplier?PartID=${PartID}&ClientID=${ClientID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async CreateSupplierPart(redirectCallback, formData) {
        try {
            const CompanyID = localStorage.getItem("CompanyID");
            formData.ClientID = CompanyID;
            const UserID = localStorage.getItem("UserID");
            formData.UserID = UserID;
            const response = await axiosInstance.post(`/Part/CreateSupplierStock`, formData);
            return response.data;
        } catch (error) {
           
            console.error('Error fetching data:', error);
            throw error;
        }
    },

    async DeleteSupplierPart(redirectCallback, ID) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Part/DeleteSupplierStock?ID=${ID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }
};

export default SupplierPartService;